import { TextStyle } from 'pixi.js'
import { useCallback } from 'react'
import { Container, Graphics, Sprite, Text } from '@pixi/react'
import { useErrorPopupStore } from '../../domain/errorHandle/store/errorPopupStore'
import { Draw } from '../../type/PixiType'
import { Button, FixedContainerV2 } from '../../UI'
import { t } from '../../domain/language/languageUtil'
import { ErrorType } from '../../domain/errorHandle/model/ErrorType'
import { isXinStarDemoMode, isXinStarPlayMode } from '../../domain/customize'

interface ErrorPopupProps {
  gameWidth: number
  gameHeight: number
  width?: number
  height?: number
}

export function ErrorPopup({ gameWidth, gameHeight, width = 816, height = 515 }: ErrorPopupProps) {
  const errorPopupStore = useErrorPopupStore()

  const x = (gameWidth - width) / 2
  const y = (gameHeight - height) / 2

  const backgroundDraw = useCallback<Draw>((background) => {
    background.clear()
    background.beginFill('#0D0A02')
    background.drawRoundedRect(0, 0, width - 4, height, 10)
  }, [height, width])

  const borderDraw = useCallback<Draw>((border) => {
    const borderWidth = 2
    const borderRadius = 10
    border.clear()
    border.lineStyle(borderWidth, '#DBD2CA', 1)
    border.drawRoundedRect(-borderWidth, 0, width - borderWidth, height - borderWidth, borderRadius)
  }, [height, width])

  // const errorMessage = errorPopupStore.type ? t(errorPopupStore.type?.toString()) : ''
  const key = errorPopupStore.type?.toString()
  const popupButtonOnClick = () => errorPopupStore.okCallback?.()
  const translatedMessage = key ? t(key) : ''
  const errorMessage = translatedMessage === key || !translatedMessage ? t('error_popup_system_error') : translatedMessage
  const disablePopupButton = (key === ErrorType.SignalRDisconnected || key === ErrorType.SessionExpired) && (isXinStarDemoMode() || isXinStarPlayMode())

  return errorPopupStore.isShow && (
    <FixedContainerV2 name="ErrorPopup" width={gameWidth} height={gameHeight} background="0x000000" backgroundAlpha={0.6} blockEvents={true} eventMode="static">
      <Container position={[x, y]}>
        <Graphics draw={backgroundDraw} />
        <Graphics draw={borderDraw} />
        <Sprite
          x={(width - 128) / 2}
          y={disablePopupButton ? 80 : 44}
          width={128}
          height={112}
          name="ErrorIcon"
          image="icon_error"
        />
        <Text
          text={errorMessage}
          x={width / 2}
          y={disablePopupButton ? 320 : 240}
          anchor={[0.5, 0.5]}
          style={
            new TextStyle({
              fontSize: 40,
              fontWeight: 'bold',
              fontFamily: 'Arial',
              fill: '#F0E1D4',
              align: 'center',
              wordWrap: true,
              breakWords: true,
              wordWrapWidth: 700,
              lineHeight: 60,
            })
          }

        />
        <Button
          name="ErrorCloseButton"
          x={(width - 270) / 2}
          y={380}
          width={270}
          height={84}
          onPress={popupButtonOnClick}
          defaultView="error_popup_btn_normal"
          hoverView="error_popup_btn_hover"
          pressedView="error_popup_btn_hover"
          visible={!disablePopupButton}
        />
        <Text
          text={t('error_popup_ok')}
          x={width / 2}
          y={423}
          anchor={[0.5, 0.5]}
          style={
            new TextStyle({
              fontSize: 36,
              fontWeight: 'bold',
              fontFamily: 'Arial',
              fill: '#F0E1D4',
              align: 'center',
              wordWrap: true,
              breakWords: true,
            })
          }
          eventMode="passive"
          visible={!disablePopupButton}
        />

      </Container>
    </FixedContainerV2>
  )
}
